import { format } from 'date-fns';

import checkAccess from 'utils/roles/checkAccess';
import getFranchiseRegion from 'utils/jwt/getFranchiseRegion';

export const routerPath = {
  root: '/personal-trainers-commission-report',
};

export const getColumns = () => [
  {
    id: 'dateMonth',
    label: 'Month',
    align: 'left',
    nameForSort: 'date',
    customValue: (item) => format(new Date(item.date), 'MMMM'),
  },
  {
    id: 'dateYear',
    label: 'Year',
    align: 'center',
    nameForSort: 'date',
    customValue: (item) => format(new Date(item.date), 'yyyy'),
  },
  {
    id: 'personalTrainerName',
    label: 'Personal Trainer',
    align: 'center',
    nameForSort: 'name',
  },
  {
    id: 'sessionsCount',
    label: 'Sessions',
    align: 'center',
    nameForSort: 'sessions',
  },
  {
    id: 'commissionLevelPercentage',
    label: 'Commissions %',
    align: 'center',
    nameForSort: 'commission_level_percentage',
  },
  {
    id: 'commissionAmount',
    label: 'Commissions',
    align: 'center',
    nameForSort: 'commission',
  },
];

export const getFilters = ({ region, personalTrainerId, yearMonthTo, yearMonthFrom, options }) => [
  {
    id: 'personalTrainerId',
    type: 'select',
    label: 'Personal Trainer',
    value: personalTrainerId.value,
    action: personalTrainerId.change,
    items: options?.allPersonalTrainers?.length ? ['all', ...options.allPersonalTrainers] : ['all'],
  },
  {
    id: 'yearMonthFrom',
    type: 'yearMonth',
    label: 'From',
    value: yearMonthFrom.value,
    action: yearMonthFrom.change,
  },
  {
    id: 'yearMonthTo',
    type: 'yearMonth',
    label: 'To',
    value: yearMonthTo.value,
    action: yearMonthTo.change,
  },
  {
    id: 'region',
    type: 'select',
    label: 'Region',
    value: checkAccess([2]) ? getFranchiseRegion() : region.value,
    action: region.change,
    items: options?.regions?.length ? ['all', ...options.regions] : ['all'],
    disabledEdit: checkAccess([2]),
  },
];
